import React from 'react';
import './MaterialList.css';

const MaterialList = ({ selectedMaterial, quantities, onQuantityChange }) => {
  if (!selectedMaterial) {
    return (
      <div className="material-list">
        <div className="no-selection">
          <div className="no-selection-icon">🌱</div>
          <h3>Select a Material Type</h3>
          <p>Choose a material type from the right panel to view its subcategories and enter quantities.</p>
        </div>
      </div>
    );
  }

  const handleQuantityChange = (material, value) => {
    // Validate input: ensure non-negative numbers
    const numValue = parseFloat(value) || 0;
    const validValue = Math.max(0, numValue);
    onQuantityChange(selectedMaterial.type, material, validValue);
  };

  return (
    <div className="material-list">
      <div className="material-list-header">
        <h2 className="section-title">
          <span className="section-icon">{selectedMaterial.icon}</span>
          {selectedMaterial.type} Materials
        </h2>
        <p className="section-subtitle">Enter quantities in pounds for each material type</p>
      </div>
      
      <div className="subcategories-container">
        {selectedMaterial.materials.map((material) => (
          <div key={material} className="subcategory-card">
            <div className="subcategory-name">{material}</div>
            <div className="quantity-section">
              <label className="quantity-label">Quantity (Lbs)</label>
              <div className="quantity-input-container">
                <input
                  type="number"
                  min="0"
                  step="0.1"
                  placeholder="0.0"
                  value={quantities[selectedMaterial.type]?.[material] || ''}
                  onChange={(e) => handleQuantityChange(material, e.target.value)}
                  className="quantity-input"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MaterialList;
